import { CurrencyDollar, CheckCircle, EnvelopeOpen, PaperPlaneRight } from '@phosphor-icons/react';

export default function CartRecoveryMetrics({ data }: { data?: any }) {
  const metrics = [
    {
      label: 'Abandoned Carts',
      value: (data?.totalAbandoned ?? 0).toLocaleString(),
      change: 'vs last month',
      icon: CurrencyDollar,
      color: '#E58A00',
    },
    {
      label: 'Recovered Revenue',
      value: `KES ${Number(data?.revenueRecovered ?? 0).toLocaleString()}`,
      change: 'recovery conversion',
      icon: CheckCircle,
      color: '#006838',
    },
    {
      label: 'Automated Recovery Messages Sent',
      value: `${data?.emailsSent ?? 0} emails`,
      change: 'delivery rate',
      icon: PaperPlaneRight,
      color: '#2C6ECB',
    },
    {
      label: 'Recovery Rate',
      value: `${data?.recoveryRate ?? 0}%`,
      change: 'recovered from messages sent',
      icon: EnvelopeOpen,
      color: '#6438B5',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics.map((item, idx) => {
        const Icon = item.icon;
        return (
          <div
            key={idx}
            className="bg-white dark:bg-[#1A1D21] rounded-xl border border-[#D2D5D9] dark:border-slate-800 p-3.5 shadow-sm"
          >
            <div className="flex items-center justify-between text-xs font-semibold text-gray-500 mb-2">
              <span>{item.label}</span>
              <div
                className="w-7 h-7 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${item.color}15`, color: item.color }}
              >
                <Icon weight="fill" className="w-4 h-4" />
              </div>
            </div>
            <div className="text-xl font-bold font-mono text-[#202223] dark:text-white">
              {item.value}
            </div>
            <p className="text-xs text-gray-400 mt-1">{item.change}</p>
          </div>
        );
      })}
    </div>
  );
}
